import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BestRxUploadForm from "./-form";
import { Header } from "@/components/universal/header";

export const Route = createFileRoute("/_private/_admin/best-rx/")({
  component: BestRxUploadPage,
});

function BestRxUploadPage() {
  return (
    <div>
      <title>BestRx Upload - Legrande Health Portal</title>
      <Header crumbs={[{ link: { to: "/best-rx" }, name: "BestRx" }]} />
      <Card>
        <CardHeader>
          <CardTitle>BestRx CSV Upload</CardTitle>
          <CardDescription>Upload a BestRx CSV file below.</CardDescription>
        </CardHeader>
        <CardContent>
          <BestRxUploadForm />
        </CardContent>
      </Card>
    </div>
  );
}
